"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));
var _moment = _interopRequireDefault(require("moment"));
var _InputDatePicker = _interopRequireDefault(require("../DatePicker/InputDatePicker"));
var _jquery = _interopRequireDefault(require("jquery"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DownloadPopup = /*#__PURE__*/function (_Component) {
  _inherits(DownloadPopup, _Component);
  var _super = _createSuper(DownloadPopup);
  function DownloadPopup(props) {
    var _this;
    _classCallCheck(this, DownloadPopup);
    _this = _super.call(this, props);
    _this.handleChange = function (data, dateType) {
      _this.props.resetError();
      _this.setState(_defineProperty({}, dateType, data));
    };
    _this.handleSave = function (dateType) {
      // let fromDate =this.state.selectedDownloadFromDate.toDate();
      // let toDate = this.state.selectedDownloadToDate.toDate();
      // let currentDate = new Date();
      // else if( ( currentDate.getDate() === fromDate.getDate() 
      // && currentDate.getMonth() === fromDate.getMonth()  && currentDate.getFullYear() === fromDate.getFullYear()) 
      // ||(currentDate.getDate() === toDate.getDate() 
      // && currentDate.getMonth() === toDate.getMonth()  && currentDate.getFullYear() === toDate.getFullYear()) ){
      //   this.setState({
      //     dateError: " Date should not be today's date "
      //   });
      // } 
      if (_this.state.selectedDownloadFromDate.isAfter(_this.state.selectedDownloadToDate)) {
        _this.setState({
          dateError: _this.props.i18next.t("lable.formDateNotGreaterThanTodate")
        });
      } else if (_this.state.selectedDownloadFromDate.isAfter((0, _moment["default"])())) {
        _this.setState({
          dateError: _this.props.i18next.t("lable.formDateNotGreaterThanCurrentTime")
        });
      } else if (_this.state.selectedDownloadToDate.isAfter((0, _moment["default"])())) {
        _this.setState({
          dateError: _this.props.i18next.t("lable.toDateNotGreaterThanCurrentTime")
        });
      } else if (_this.state.selectedDownloadFromDate.isBefore((0, _moment["default"])().subtract(40, 'days'))) {
        _this.setState({
          dateError: _this.props.i18next.t("lable.fromDateshouldPast40Days")
        });
      } else if (_this.state.selectedDownloadToDate.isBefore((0, _moment["default"])().subtract(40, 'days'))) {
        _this.setState({
          dateError: _this.props.i18next.t("lable.toDateshouldPast40Days")
        });
      } else {
        _this.setState({
          dateError: ""
        });
      }
      _this.setState(_defineProperty({}, dateType, dateType === "downloadFrom" ? _this.state.selectedDownloadFromDate : _this.state.selectedDownloadToDate));
    };
    _this.state = {
      selectedDownloadFromDate: (0, _moment["default"])(),
      selectedDownloadToDate: (0, _moment["default"])(),
      downloadFrom: null,
      downloadTo: null,
      showFromDatePicker: false,
      showToDatePicker: false,
      handLimitError: "",
      //"Over 10K hand download limit, reduce time period."
      dateError: ""
    };
    return _this;
  }
  _createClass(DownloadPopup, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal fade",
        "data-backdrop": "static",
        id: "downloadModal",
        role: "dialog"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "download_popup_dialog download_popup_setting_modal_dialog"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "download_popup_container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "download_popup_title"
      }, this.props.i18next.t("lable.downloadHands"), " \xA0\xA0 ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "fa fa-info-circle",
        style: {
          color: "grey"
        },
        "data-tip": true,
        "data-for": "download-info"
      })), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
        id: "download-info",
        type: "warning",
        place: "bottom",
        effect: "solid",
        className: "cust-tooltip"
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("ul", {
        style: {
          paddingLeft: "20px",
          paddingRight: "10px"
        }
      }, /*#__PURE__*/_react["default"].createElement("li", null, this.props.i18next.t("lable.commentEarliestDownload")), /*#__PURE__*/_react["default"].createElement("li", null, this.props.i18next.t("lable.commentmaximum50konetime")), /*#__PURE__*/_react["default"].createElement("li", null, this.props.i18next.t("lable.comment50KshorterPeriod"), /*#__PURE__*/_react["default"].createElement("br", null), this.props.i18next.t("lable.commentDateTimeNeccessory")), /*#__PURE__*/_react["default"].createElement("li", null, this.props.i18next.t("lable.commentHHarePlayerReview"), /*#__PURE__*/_react["default"].createElement("br", null), this.props.i18next.t("lable.reasonsAgainstPlayers")), /*#__PURE__*/_react["default"].createElement("li", null, this.props.i18next.t("lable.commentHandsAnonymised")), /*#__PURE__*/_react["default"].createElement("li", null, this.props.i18next.t("lable.commentHandsNumbernotCorrespond"), /*#__PURE__*/_react["default"].createElement("br", null), this.props.i18next.t("lable.commentAttemptToMatchPlayer")), /*#__PURE__*/_react["default"].createElement("li", null, this.props.i18next.t("lable.commentLevelWillBeExported"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dp_days_limit"
      }, this.props.i18next.t("lable.commentFromTheLast40Days")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dp_date_picker_group",
        id: "dp_date_picker_group1",
        "data-toggle": "modal",
        "data-target": "#dpFromDateTimePicker"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dp_lable"
      }, this.props.i18next.t("lable.downloadFrom"), ":"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dp_selector_dropdown"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "dp_datepicker_text",
        "data-e2e": "DownLoadFromDate"
      }, this.state.showFromDatePicker ? (0, _moment["default"])(this.state.downloadFrom).format("DD/MM/YYYY") : this.props.i18next.t("lable.selectDate")), /*#__PURE__*/_react["default"].createElement("span", {
        className: "dp_arrow_icon"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "fas fa-angle-down"
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "download_from_datepicker"
      }, /*#__PURE__*/_react["default"].createElement(_InputDatePicker["default"], {
        modalId: "dpFromDateTimePicker",
        selectedDate: this.state.selectedDownloadFromDate,
        handleChange: function handleChange(data) {
          _this2.handleChange(data, "selectedDownloadFromDate");
        },
        handleSave: function handleSave() {
          _this2.handleSave("downloadFrom");
          (0, _jquery["default"])('#dp_date_picker_group1').click();
          _this2.setState({
            showFromDatePicker: true
          });
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dp_date_picker_group",
        id: "dp_date_picker_group2",
        "data-toggle": "modal",
        "data-target": "#dpToDateTimePicker"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dp_lable"
      }, this.props.i18next.t("lable.downloadTo"), ":"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dp_selector_dropdown"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "dp_datepicker_text",
        "data-e2e": "DownloadDateTo"
      }, this.state.showToDatePicker ? (0, _moment["default"])(this.state.downloadTo).format("DD/MM/YYYY") : this.props.i18next.t("lable.selectDate")), /*#__PURE__*/_react["default"].createElement("span", {
        className: "dp_arrow_icon"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "fas fa-angle-down"
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "download_to_datepicker"
      }, /*#__PURE__*/_react["default"].createElement(_InputDatePicker["default"], {
        modalId: "dpToDateTimePicker",
        selectedDate: this.state.selectedDownloadToDate,
        handleChange: function handleChange(data) {
          _this2.handleChange(data, "selectedDownloadToDate");
        },
        handleSave: function handleSave() {
          _this2.handleSave("downloadTo");
          (0, _jquery["default"])('#dp_date_picker_group2').click();
          _this2.setState({
            showToDatePicker: true
          });
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "over-10-k-hand-download",
        "data-e2e": "error in downloadHands"
      }, this.state.dateError ? this.state.dateError : this.state.handLimitError ? this.state.handLimitError : this.props.error ? this.props.error : ""), this.state.showFromDatePicker && this.state.showToDatePicker && this.state.dateError === "" && this.state.handLimitError === "" && this.props.error === "" ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        onClick: function onClick() {
          _this2.props.onDownload(_this2.state.downloadFrom, _this2.state.downloadTo);
        },
        className: "mg-btn dp_download_btn"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "dp_download_text",
        "data-e2e": "hands-download"
      }, this.props.i18next.t("lable.download")))) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        onClick: function onClick() {},
        className: "mg-btn dp_select_time_btn"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "dp_select_time_text",
        "data-e2e": "timeperiod"
      }, this.props.i18next.t("lable.selectDateRange")))), /*#__PURE__*/_react["default"].createElement("span", {
        className: "download_popup_setting_closeButton",
        id: "download_popup_setting_closeButton_id",
        onClick: function onClick() {
          _this2.props.resetError();
        },
        "data-dismiss": "modal"
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "fas fa-times",
        "data-e2e": "downloadHandsClose"
      }))))));
    }
  }]);
  return DownloadPopup;
}(_react.Component);
var _default = DownloadPopup;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/DownloadPopup/DownloadPopup.js
 ** module id = 2377
 ** module chunks = 0
 **/